import script from "./SubareaAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./SubareaAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./SubareaAnalysis.vue?vue&type=style&index=0&id=1e62c951&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e62c951"]])

export default __exports__